import axios from "axios";
import {API_URL_BASE, LANGUAGES_SLUG} from "./constants";

export default async function getLanguagesApi () {
    return axios(`${API_URL_BASE}${LANGUAGES_SLUG}`);
}